import { IProviderForm, IProviderResponse } from 'services/providers/types';

export const providerQueryToForm = (
  response: IProviderResponse
): IProviderForm => {
  const { id, ...provider } = {
    ...response,
    salesChannels: response.salesChannels.map(channel => ({
      salesChannelId: channel.salesChannelId,
      name: channel.name,
      deliveryTypeId: channel.deliveryMethod.deliveryType.id,
      transferMethodId: channel.deliveryMethod.transferMethod.id,
      expectTimestamp: channel.deliveryMethod.expectTimestamp,
      waitForAssetId: channel.deliveryMethod.waitForAssetId,
    })),
  };
  return provider;
};
